import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let concep = '';

class HorasDiasInhabiles extends Component {
    constructor(props){
        super(props);
        this.state = {

            busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionario: '',
                desdeBusqueda: '',
                hasta: '',
                ubicacion: '',
                ubicacionCentral: '',
            },

            horasDiasInhabiles: {
                numeroFuncionario: '',
                codigo: '',
                nombreFuncionario: '',
                dias: '0',
                minutos: '0',
                fecha: '',
                usuario: sessionStorage.numeroFuncionario,
                funAsociado: sessionStorage.numeroFuncionarioAsociado,
            },

            movEditar:{
                idMovimientoHorasDias: '',
                numeroFuncionario: '',
                codigo: '',
                nombreFuncionario: '',
                dias: '0',
                minutos: '0',
                fecha: '',
                diasAnterior: '0',
                minutosAnterior: '0',
            },

            checkAdd: false,

            consulta: false,
            codigosMovimientos: [],
            notificaciones: null,
            errores: null,
            numeroNombre: [],
            horasDiasFuncionario: [],
            modalActualizar: false,
            modalBorrar: false,
            lugaresTra: [],
            ubicacionesCentral: [],

        }
        this.manejarCambioNumFun = this.manejarCambioNumFun.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioHorasDias = this.manejarEnvioHorasDias.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarEdicion = this.manejarEdicion.bind(this);
        this.manejarBorrar = this.manejarBorrar.bind(this);
        this.manejarCambioEditar = this.manejarCambioEditar.bind(this);
        this.manejarEnvioModificar = this.manejarEnvioModificar.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.obtenerCal = this.obtenerCal.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.horasDiasAgregar = this.horasDiasAgregar.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
    }
    async componentDidMount(){
        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datos = await respuesta.json();
        this.setState({
            codigosMovimientos: datos,
        });


        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

    }

    render(){
        return (
            <>
            <Container>
                <h3>Horas y Días Inhábiles</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {/*<form className='formulario1'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                    <Box sx={{ flexGrow: 1}} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2.1}>
                                <Item>Número de Funcionario</Item>
                            </Grid>
                            <Grid item xs={3}>
                                <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambioNumFun} type="number" /></Item>
                            </Grid>
                            <Grid item xs={3}>
                                <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambioNumFun}/></Item>
                            </Grid>
                            <Grid item xs={1}>
                                <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                            </Grid>
                        </Grid>
                    </Box>
                </form>*/}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consulta ? null : <FormControlLabel label='Agregar Horas/Días' control={<Checkbox checked={this.state.checkAdd} onChange={this.horasDiasAgregar} id='add'  inputProps={{ 'aria-label': 'controlled' }} />  }/>}
                {this.state.checkAdd || this.state.consulta
                ?
                    null
                :
                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                    <Table sx={{minWidth: 700}}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Concepto</StyledTableCell>
                                <StyledTableCell>N. Funcionario</StyledTableCell>
                                <StyledTableCell>Nombre</StyledTableCell>
                                <StyledTableCell>Desde</StyledTableCell>
                                <StyledTableCell>Hasta</StyledTableCell>
                                <StyledTableCell>Ubicación</StyledTableCell>
                                {this.state.busqueda.ubicacion === '0' ? <StyledTableCell></StyledTableCell> : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambioNumFun}>
                                        <option value=''>CONCEPTO</option>
                                        <option key={28} value={28}>HORAS INHÁBILES</option>
                                        <option key={29} value={29}>DÍAS INHÁBILES / TURISMO</option>
                                        <option key={46} value={46}>HORAS SIMPLES</option>
                                    </select>
                                </StyledTableCell>
                                <StyledTableCell><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambioNumFun} type="number" /></StyledTableCell>
                                <StyledTableCell>{this.state.busqueda.nombreFuncionario}</StyledTableCell>
                                <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambioNumFun} type="date" /></StyledTableCell>
                                <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{border: "2px solid #D6EAF8", width: "100%"}} id='hasta' value={this.state.busqueda.hasta} onChange={this.manejarCambioNumFun} type="date" /></StyledTableCell>
                                <StyledTableCell>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacion'  value={this.state.busqueda.ubicacion} onChange={this.manejarCambioNumFun}>
                                        <option value=''>UBICACION</option>
                                        {this.state.lugaresTra.map((name) =>
                                            <option
                                            key={name.idLugaresTrabajo}
                                            value={name.idLugaresTrabajo}
                                            >{name.lugar}</option>
                                            )}
                                    </select>
                                </StyledTableCell>
                                {this.state.busqueda.ubicacion === '0'
                                ?
                                    <StyledTableCell>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.busqueda.ubicacionCentral} onChange={this.manejarCambioNumFun}>
                                            <option value=''>UBICACION</option>
                                            {this.state.ubicacionesCentral.map((name) =>            
                                                <option
                                                key={name.idUbicacionesCentral}
                                                value={name.idUbicacionesCentral}
                                                >{name.descripcion}
                                            </option>
                                                )}
                                        </select>
                                    </StyledTableCell>
                                :
                                    null
                                }
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                }
                {this.state.consulta
                ?
                    <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                    </ReactHtmlTableToExcel>
                :
                    null
                }
                {this.state.checkAdd || this.state.consulta
                ?
                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto', marginTop: '1rem'}} component={Paper}>
                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell width={'16%'}>Concepto</StyledTableCell>
                                    <StyledTableCell>Número</StyledTableCell>
                                    <StyledTableCell>Nombre</StyledTableCell>
                                    <StyledTableCell>Días</StyledTableCell>
                                    <StyledTableCell>Minutos</StyledTableCell>
                                    <StyledTableCell>Fecha</StyledTableCell>
                                    {this.state.consulta ? <StyledTableCell></StyledTableCell> : null}
                                    {this.state.consulta ? <StyledTableCell></StyledTableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/*Acá va la carga de base de datos */}
                                {this.state.horasDiasFuncionario.map((datosAg) => (
                                    <StyledTableRow key={datosAg.idMovimientoHorasDias}>
                                        {/*<StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={datosAg.codigo} onChange={this.manejarCambiosDatos}>
                                                <option value=''>CONCEPTO</option>
                                                <option key={28} value={28}>HORAS INHÁBILES</option>
                                                <option key={29} value={29}>DÍAS INHÁBILES / TURISMO</option>
                                                <option key={46} value={46}>HORAS SIMPLES</option>
                                            </select>
                                        </StyledTableCell>*/}
                                        {datosAg.codigo === 28
                                        ?
                                            <StyledTableCell>HORAS INHÁBILES</StyledTableCell>
                                        :
                                            datosAg.codigo === 29
                                            ?
                                                <StyledTableCell>DÍAS INHÁBILES / TURISMO</StyledTableCell>
                                            :
                                                datosAg.codigo === 46
                                                ?
                                                    <StyledTableCell>HORAS SIMPLES</StyledTableCell>
                                                :
                                                    null
                                        }
                                        <StyledTableCell>{datosAg.numeroFuncionario}</StyledTableCell>
                                        <StyledTableCell>{datosAg.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell>{datosAg.dias}</StyledTableCell>
                                        <StyledTableCell>{datosAg.minutos}</StyledTableCell>
                                        <StyledTableCell>{datosAg.fecha.substring(8,10) + '/' + datosAg.fecha.substring(5,7) + '/' + datosAg.fecha.substring(0,4)}</StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-danger mx-2" onClick={() => this.manejarEdicion(datosAg)}>Editar</button></StyledTableCell>
                                        <StyledTableCell><button className="btn btn-outline-dark mx-2" type='button' onClick={() => this.manejarBorrar(datosAg)}>Borrar</button></StyledTableCell>
                                    </StyledTableRow>
                                ))}
                                {this.state.consulta  ? '' :
                                    <StyledTableRow>
                                        <StyledTableCell>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.horasDiasInhabiles.codigo} onChange={this.manejarCambiosDatos}>
                                                <option value=''>CONCEPTO</option>
                                                <option key={28} value={28}>HORAS INHÁBILES</option>
                                                <option key={29} value={29}>DÍAS INHÁBILES / TURISMO</option>
                                                <option key={46} value={46}>HORAS SIMPLES</option>
                                            </select>
                                        </StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionario' value={this.state.horasDiasInhabiles.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        <StyledTableCell>{this.state.horasDiasInhabiles.nombreFuncionario}</StyledTableCell>
                                        <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='dias' value={this.state.horasDiasInhabiles.dias} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                        {this.state.horasDiasInhabiles.codigo === '29' ? <StyledTableCell></StyledTableCell> : <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutos' value={this.state.horasDiasInhabiles.minutos} onChange={this.manejarCambiosDatos}/></StyledTableCell>}
                                        <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fecha' value={this.state.horasDiasInhabiles.fecha} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                    </StyledTableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                :
                    null
                }
                {this.state.consulta || (this.state.checkAdd)? '' : <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioConsulta}>Consultar</button>}
                {this.state.consulta || (!this.state.checkAdd)? '' : <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioHorasDias}>Agregar</button>}
                {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : ''}
            </Container>
            <Modal open={this.state.modalActualizar}>
                <form className='formulario1'>
                <Box sx={styleModal} >
                    <h3 style={{textAlign:'center'}}>Editar Movimiento</h3>
                    <Grid container spacing={2} rowSpacing={1}>
                        <Grid item xs={6}>
                            <Item>Número Funcionario</Item>
                        </Grid>
                        <Grid item xs={5}>
                            <Item>{this.state.movEditar.numeroFuncionario}</Item>
                        </Grid>
                        <Grid item xs={1}>

                        </Grid>
                        <Grid item xs={6}>
                            <Item>Nombre Funcionario</Item>
                        </Grid>
                        <Grid item xs={5}>
                            <Item>{this.state.movEditar.nombreFuncionario}</Item>
                        </Grid>
                        <Grid item xs={1}>
                            
                        </Grid>
                        <Grid item xs={6}>
                            <Item>Concepto</Item>
                        </Grid>
                        <Grid item xs={5}>
                            <Item>
                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.movEditar.codigo} onChange={this.manejarCambiosDatos}>
                                    <option value=''>CONCEPTO</option>
                                    <option key={28} value={28}>HORAS INHÁBILES</option>
                                    <option key={29} value={29}>DÍAS INHÁBILES / TURISMO</option>
                                    <option key={46} value={46}>HORAS SIMPLES</option>
                                </select>
                            </Item>
                        </Grid>
                        <Grid item xs={1}>
                            
                        </Grid>
                        <Grid item xs={6}>
                            <Item>Dias</Item>
                        </Grid>
                        <Grid item xs={5}>
                            <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='dias' value={this.state.movEditar.dias} onChange={this.manejarCambioEditar}/></Item>
                        </Grid>
                        <Grid item xs={1}>
                            
                        </Grid>
                        <Grid item xs={6}>
                            <Item>Minutos</Item>
                        </Grid>
                        <Grid item xs={5}>
                            <Item><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutos' value={this.state.movEditar.minutos} onChange={this.manejarCambioEditar}/></Item>
                        </Grid>
                        <Grid item xs={1}>
                            
                        </Grid>
                        <Grid item xs={6}>
                            <Item>Fecha</Item>
                        </Grid>
                        <Grid item xs={5}>
                            <Item><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='fecha' value={this.state.movEditar.fecha} onChange={this.manejarCambioEditar}/></Item>
                        </Grid>
                        <Grid item xs={1}>
                            
                        </Grid>
                        <Grid item xs={4}>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioModificar}>Confirmar</button>
                        </Grid>
                        <Grid item xs={4}>
                            <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                        </Grid>
                    </Grid>
                </Box>
                </form>
            </Modal>
            <Modal open={this.state.modalBorrar}>
                <form className='formulario1'>
                    <Box sx={styleModal} >
                    <h3 style={{textAlign:'center'}}>¿Confirmar Baja Movimiento?</h3>
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={4}>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                            </Grid>
                            <Grid item xs={4}>
                                <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
            </Modal>
            </>
        )//Final return
    }//final Render

    manejarCambioNumFun(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            if(clave === 'numeroFuncionarioBusqueda'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    horasDiasAgregar(){
        if(this.state.checkAdd){
            this.setState({
                checkAdd: false,
            })
        }else{
            this.setState({
                checkAdd: true,
            })
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const horasDiasActualizado = state.horasDiasInhabiles;
            if(clave === 'numeroFuncionario'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    horasDiasActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    horasDiasActualizado['nombreFuncionario'] = '';
                }
                });
            }
            horasDiasActualizado[clave] = valor;
            return{
                horasDiasInhabiles: horasDiasActualizado,
            };
        })
    }

    async manejarEnvioHorasDias(e){
        e.preventDefault();
        if(this.state.horasDiasInhabiles.codigo === ''){
            this.setState({
                errores: 'Debe seleccionar un concepto!',
            });
        }else if(this.state.horasDiasInhabiles.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario!',
            });
        }else if(this.state.horasDiasInhabiles.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un numero de funcionario valido!',
            });
        }else if(this.state.horasDiasInhabiles.dias === ''){
            this.setState({
                errores: 'Debe ingresar los días!',
            });
        }else if((this.state.horasDiasInhabiles.dias === '0') && (this.state.horasDiasInhabiles.codigo === '29')){
            this.setState({
                errores: 'Debe ingresar los días!',
            });
        }else if(this.state.horasDiasInhabiles.minutos === ''){
            this.setState({
                errores: 'Debe ingresar los minutos!',
            });
        }else if((this.state.horasDiasInhabiles.minutos === '0') && (this.state.horasDiasInhabiles.dias === '0') && (this.state.horasDiasInhabiles.codigo !== '29')){
            this.setState({
                errores: 'Los días y minutos no pueden ser los dos 0!',
            });
        }else if(this.state.horasDiasInhabiles.fecha === ''){
            this.setState({
                errores: 'Debe ingresar la fecha!',
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.horasDiasInhabiles);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/guardar_horasDias.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });

            if(res === 'ok'){
                this.setState({
                    notificaciones: 'Los datos fueron ingresados correctamente',
                    errores: null,
                    horasDiasInhabiles: {
                        numeroFuncionario: '',
                        codigo: '',
                        nombreFuncionario: '',
                        dias: '0',
                        minutos: '0',
                        fecha: '',
                        usuario: sessionStorage.numeroFuncionario,
                        funAsociado: sessionStorage.numeroFuncionarioAsociado,
                    },
                });
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            horasDiasFuncionario: [],
            errores: null,
            notificaciones: null,
            busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionario: '',
                desdeBusqueda: '',
                hasta: '',
                ubicacion: '',
                ubicacionCentral: '',
            },
        });
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            loading: true,
        });

        const cargaUtil = JSON.stringify([this.state.busqueda]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_horasDiasGenerados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            loading: false,
            errores: exito[0],
            notificaciones: null,
        })

        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                horasDiasFuncionario: exito[1],
                consulta: true,
            })
        }
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(this.state.busqueda.numeroFuncionarioBusqueda === ''){
            this.setState({
                errores: "DEBE INGRESAR UN NUMERO DE FUNCIONARIO!",
            });
        }else if (this.state.busqueda.desdeBusqueda === ''){
            this.setState({
                errores: "Debe indicar la fecha!",
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
            });

            const cargaUtil = JSON.stringify(this.state.busqueda);

            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_movimientosHorasDias.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito){
                if(exito.length !== 0){

                    this.setState({
                        consulta: true,
                        horasDiasFuncionario: exito,
                    })
                }else{
                    this.setState({
                        consulta: false,
                        horasDiasFuncionario: [],
                        errores: 'No existen movimientos para el número de funcionario ingresado!',
                    });
                }
            }
        }
    }

    manejarEdicion(dato){
        this.setState({
            modalActualizar: true,
            movEditar: dato,
            notificaciones: null,
        });
        this.setState(state => {
            const movEditarActualizado = state.movEditar;

            movEditarActualizado['diasAnterior'] = movEditarActualizado.dias;
            movEditarActualizado['minutosAnterior'] = movEditarActualizado.minutos;
            return {
                movEditar: movEditarActualizado,
            }
        })
    }

    manejarBorrar(dato){
        this.setState({
            modalBorrar: true,
            movEditar: dato,
            notificaciones: null,
        });
    }

    manejarCambioEditar(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movEditarActualizado = state.movEditar;

            movEditarActualizado[clave] = valor;
            return {
                movEditar: movEditarActualizado,
            }
        })
    }

    async obtenerCal(e){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_movimientosHorasDias.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            horasDiasFuncionario: exito,
        });
    }

    async manejarEnvioModificar(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.movEditar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/editar_movimientoHorasDias.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            modalActualizar: false,
        });
        if(exito === 'ok'){
            this.setState({
                notificaciones: 'Los datos fueron ingresados correctamente',
                modalActualizar: false,
                errores: null,
            });
        }else{
            this.setState(state => {
                const movEditarActualizado = state.movEditar;
    
                movEditarActualizado['dias'] = movEditarActualizado.diasAnterior;
                movEditarActualizado['minutos'] = movEditarActualizado.minutosAnterior;
                return {
                    movEditar: movEditarActualizado,
                }
            })
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.obtenerCal();
        this.setState({
            modalActualizar: false,
            modalBorrar: false,
        });
    }

    async manejarEnvioBaja(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.movEditar, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_movimientoHorasDias.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        if(exito){
            let contador = 0;
            const arr = this.state.horasDiasFuncionario;
            arr.map((name) => {
                if(this.state.movEditar.idMovimientoHorasDias === name.idMovimientoHorasDias){
                    arr.splice(contador, 1);
                }else{
                    contador++;
                }
            });
            this.setState({
                notificaciones: 'Los datos fueron borrados correctamente',
                modalBorrar: false,
                horasDiasFuncionario: arr,
            });
        }
    }
}

export default HorasDiasInhabiles